import React, { useEffect, useState } from 'react';
import { useCustomQuery, useSampleJson } from '../../hooks';
import FullpageLoader from '../../components/shared/FullpageLoader';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  getSectionData,
  setAccountActivationData,
  setBackButtonPath,
  setCustomQuery,
  callDiglockerCallback,
  getOverlayComponent,
  refreshDetails,
} from '../../helper-methods';
import {
  accountActivationMapping,
  overlayStates,
} from '../../helper-methods/constants';
import { useQueryClient } from 'react-query';
import AnalyticsService from '../../config/AnalyticsService';
import { cleverTapEvents } from '../../config/ClevertapEvents';
import { postError } from '../../helper-methods/index';
const DigilockerRedirection = () => {
  const { data: customerId } = useCustomQuery({ section: 'customerId' });
  const {
    data: sampleJson,
    isLoading: isSampleJsonLoading,
    isFetching,
  } = useSampleJson();
  const { data: homeSectionQueryData } = useCustomQuery({ section: 'home' });
  const { search } = useLocation();
  const urlParams = new URLSearchParams(search);
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [updatedData, _updatedData] = useState(null);
  const [overlayState, _overlayState] = useState(null);
  const { data: forwardNavigationMapping } = useCustomQuery({
    section: 'forwardNavigationMapping',
  });
  const { data: customerStatus } = useCustomQuery({ section: 'customerStatus' });
  console.log('href', window.location.href);
  console.log({ search });
  console.log({ urlParams });
  console.log("urlParams?.get('status')", urlParams?.get('status'));
  console.log("urlParams?.get('digio_doc_id')", urlParams?.get('digio_doc_id'));
  console.log({ updatedData });
  console.log({ overlayState });
  useEffect(() => {
    console.log('inside-sample-json-useEffect');
    if (isSampleJsonLoading || isFetching || homeSectionQueryData) return;
    const section = 'home';
    setCustomQuery({
      section: section,
      data: sampleJson
        ? getSectionData({ response: sampleJson, section: section })[section]
        : null,
      queryClient: queryClient,
    });
  }, [sampleJson]);

  useEffect(async () => {
    try {
      console.log('inside-digio-process-useEffect[]');
      setBackButtonPath({ data: `/home${search}`, queryClient });
      const { refreshValues, querystring } = await refreshDetails();
      console.log('refreshDetails', JSON.stringify(refreshValues));
      console.log('querystring', querystring);
      const payload = {
        // customerId: refreshValues?.customerid,
        customerId:'CUST-575d5ef5-b159-460b-9552-14532e2dd8ab',
        kycStep: 'digilocker',
        digio_id: urlParams?.get('digio_doc_id'),
        status: urlParams?.get('status'),
      };
      console.log({ payload });
      if(!urlParams?.get('status') && urlParams?.get('digio_doc_id')){
        setTimeout(() => {
          AnalyticsService.shared.send(
            cleverTapEvents.wealthMfOnboarding.name,
            cleverTapEvents.wealthMfOnboarding.section.DIGILOCKER_REDIRECT(
              "failure",
              customerStatus
            )
          );
        }, 5000);

      }
      else if(urlParams?.get('status') =='success'){
        setTimeout(() => {
          AnalyticsService.shared.send(
            cleverTapEvents.wealthMfOnboarding.name,
            cleverTapEvents.wealthMfOnboarding.section.DIGILOCKER_REDIRECT(
              "success",
              customerStatus
            )
          );
        }, 1000);
      }
      else if (!urlParams?.get('status') && !urlParams?.get('digio_doc_id')){
        // This is a params not recieved condition
        postError({ "Error": "Digilocker params not recieved" })
        setTimeout(() => {
          AnalyticsService.shared.send(
            cleverTapEvents.wealthMfOnboarding.name,
            cleverTapEvents.wealthMfOnboarding.section.DIGILOCKER_REDIRECT(
              null,
              customerStatus
            )
          );
        }, 1000);
      }
      else {
        setTimeout(() => {
          AnalyticsService.shared.send(
            cleverTapEvents.wealthMfOnboarding.name,
            cleverTapEvents.wealthMfOnboarding.section.DIGILOCKER_REDIRECT(
              "failure",
              customerStatus
            )
          );
        }, 1000);
      }
      const digilockerCallbackResponse = await callDiglockerCallback(payload);
      console.log({ digilockerCallbackResponse });
      _updatedData({ digioData: digilockerCallbackResponse, querystring });
    } catch (e) {
      console.log(e);
      _overlayState(overlayStates.EXTERNAL_API_ERROR);
    }
  }, []);

  useEffect(() => {
    if (updatedData?.digioData) {
      const digioData = updatedData?.digioData;
      const querystring = updatedData?.querystring;
      console.log('digio-data-use-effect');
      console.log({ currentDigioData: updatedData?.digioData });
      if (digioData?.data?.data?.status === 'Updated Status') {
        const { index: itemIndex } = accountActivationMapping['kyc_video'];
        setAccountActivationData({
          itemIndex: itemIndex,
          isCompleted: false,
          isDisabled: false,
          nextPath: `${forwardNavigationMapping['Digilocker']}${querystring}`,
          queryClient,
          homeSectionQueryData,
          initialUpdate: false,
        });
        // navigate(`${forwardNavigationMapping['Digilocker']}${search}`);
        console.log('redirection-to-url:', `/${querystring}`);
        navigate(`/${querystring}`);
      } else {
        console.log('redirection-to-url:', `/home${querystring}`);
        navigate(`/home${querystring}`);
      }
    }
  }, [updatedData?.digioData]);

  const closeOverlay = () => {
    console.log('close-overlay-called');
    _overlayState(null);
  };

  console.log({ sampleJson });

  return (
    <>
      {overlayState &&
        getOverlayComponent({
          subSection: null,
          messages: sampleJson?.data?.data?.messages?.common,
          overlayState,
          closeOverlay,
          ctaHandler: closeOverlay,
        })}
      <FullpageLoader />
    </>
  );
};

export default DigilockerRedirection;
